export const strategyUtil = {
  /**
   * url 参数
   * t: s 策略，m 手动
   * sid: strategyId
   * rec: recType 运营/用户创建的
   */
  parseUrl(url: Url) {
    const tab = url.query.t;
    const isStrategy = tab && tab.toLowerCase() === 's';

    const strategyId = url.query.sid;
    const recType = url.query.rec;
    let type = `${url.query.type}`.toLowerCase();
    if (url.query?.sp) {
      const sp = window.atob(url.query.sp);
      type = (sp.split(',')[0] || '').toLowerCase();
    }

    const validCopy = strategyId && recType;

    return {
      isStrategy,
      type,
      params: validCopy
        ? {
            strategyId,
            recType,
          }
        : undefined,
      sp: (isStrategy && url.query?.sp) || null,
    };
  },
  clearCopyQuery(url: Url) {
    const query = {...url.query};
    delete query.sid;
    delete query.rec;
    delete query.sp;
    return query;
  },
};
